import React, { useEffect, useState } from "react";
import TeamCard from "molecules/TeamCard";
import {
  Row,
  Col,
  Input,
  Button,
  Modal,
  Dropdown,
  message,
  Pagination,
  Tabs,
} from "antd";
import { DEVICE } from "common/Device";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getUserList,
  getUserRoleId,
  getMenuList,
  getAllDepartmentList,
  getDepartmentUserList,
  getSelectedDepartmentId,
  getUnreadChatMessageList,
  getUserInfo,
  getDepartmentList,
  getClientid,
  getlevelList,
  getSupervisorList,
  getRoleList,
} from "redux/selectors";
import { setUserList, toggleSuccessModal } from "redux/actions";
import styled from "@emotion/styled";
import {
  map,
  concat,
  size,
  uniqBy,
  includes,
  find,
  result,
  uniq,
  flatMap,
  get,
} from "lodash";
import COLORS from "common/Colors";
import EventBus from "utils/EventBus";
import { useRef } from "react";
import { encrypt, STATUS_CODE, TOPGRADESUPERVISORLIST } from "common/Constants";
import { CALL_API, FETCH_FULL_USER_LIST } from "common/API";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { ReactComponent as IconLink } from "../assets/Component 275 – 1.svg";
import AddEmployee from "organisms/AddEmployee";
import useEmployeeFilter from "hooks/useEmployeeFilter";
import { CSVLink } from "react-csv";

const StyledCol = styled(Col)`
  padding: 10px;
`;

const StyledTitle = styled.div`
  padding-left: 10px;
  padding-bottom: 10px;
  .ant-row {
    display: flex;
    flex-direction: column;
  }
  .ant-tabs-ink-bar {
    background-color: #000;
  }
  .ant-tabs-tab:hover {
    color: #000;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #000 !important;
  }
  .ant-tabs-tab {
    color: #b2beb5;
  }
`;

const StyledFilterRow = styled(Row)`
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  border-radius: 10px;
  .people_font_style {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 20.83px;
  }
  .selectbox {
    width: 100%;
    border-radius: 10px !important;
  }
  .ant-select-selector {
    border-radius: 10px !important;
  }
  .broadcast {
    width: 60px;
    height: 60px;
  }
  @media ${DEVICE.tablet} {
    .selectbox {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
`;

const StyledFooterDiv = styled.div`
  text-align: right;
  padding-top: 10px;
  .ant-btn {
    font-weight: bold !important;
    color: ${COLORS.PRIMARY};
    padding-right: 0px !important;
  }
  .ant-btn:hover {
    border: none;
  }
`;

function Team({
  userList,
  allDepartmentList,
  updateSuccessModal,
  unreadChatMessageList,
  selectedDepartmentId,
  levelList,
  supervisorList,
  userRoleId,
  roleList,
  userInfo,
  clientId,
  updateUserList,
  menuList,
}) {
  // Adding people (form / onboarding link) needs create on HR Resources -> People
  const Menulist = menuList?.[userRoleId] || Object.values(menuList || {})[0];
  const canAddPeople = !!Menulist?.find(
    (item) =>
      item?.key === "HRResources" &&
      item?.subMenu?.find(
        (subItem) => subItem?.key === "team" && subItem?.permission?.create
      )
  );
  const [isBroadcastModalVisible, toggleBroadcastModalVisible] =
    useState(false);
  const [displayAddEmployeeModal, toggleAddEmployeeModal] = useState(false);
  const [sendingMessageLoader, ToggleSendingMessageLoader] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [broadcastMessage, setBroadcastMessage] = useState("");
  const [employeeType, setEmployeeType] = useState("1"); // "1" for active, "0" for inactive
  const [activeTabKey, setActiveTabKey] = useState(1);
  const [employeeFilterList, setEmployeeFilterList] = useState([]);
  const { TextArea } = Input;
  const containerRef = useRef(null);

  const userClientId = useSelector(getClientid);
  const [encryptedClientId, setEncryptedClientId] = useState("");

  useEffect(() => {
    const encryptId = async () => {
      if (userClientId) {
        const result = await encrypt(String(userClientId));
        setEncryptedClientId(result);
      }
    };
    encryptId();
  }, [userClientId]);

  let currentPath = window.location.pathname;
  let pathSegments = currentPath.split("/");
  let url = pathSegments[pathSegments.length - 1];

  useEffect(() => {
    setSelectedDepartment(selectedDepartmentId);
  }, [selectedDepartmentId]);

  const [managingOfficeData, setManagingOfficeData] = useState([]);
  const [competencyQCData, setCompetencyQCfetchData] = useState([]);
  const [servicelineData, setServicelinefetchData] = useState([]);
  const [subservicelineData, setsubservicelineData] = useState([]);
  const [departmentLevelData, setDepartmentLevelData] = useState([]);
  const [employeeCSVlist, setEmployeeCSVlist] = useState([]);
  const csvLinkRef = useRef();

  const SUPER_ADMIN_ROLE_ID = "2";
  const HR_ROLE_ID = "7";

  const CSVHeaders = [
    { label: "Salutation", key: "salutation" },
    { label: "Initial", key: "initial" },
    { label: "User Id", key: "userid" },
    { label: "Name", key: "fullname" },
    { label: "Employee Id", key: "employeeid" },
    { label: "Start Date", key: "startdate" },
    { label: "Date of Birth", key: "dob" },
    { label: "Gender", key: "gender" },
    { label: "Age", key: "age" },
    { label: "Marital Status", key: "maritalstatus" },
    { label: "No Of Dependent", key: "dependents" },
    { label: "Greetings", key: "greetings" },
    { label: "Nationality", key: "nationality" },
    { label: "Address", key: "address" },
    { label: "Phone No", key: "phoneno" },
    { label: "Country", key: "managingoffice" },
    { label: "Competency/ QC", key: "competencyQC" },
    { label: "Service Line", key: "serviceline" },
    { label: "Sub Serviceline", key: "subserviceline" },
    { label: "Department", key: "leveldepartmentname" },
    { label: "Competency Role", key: "competencyrole" },
    { label: "Institute Name", key: "institutename" },
    { label: "Location", key: "location" },
    { label: "Supervisor / Manager", key: "supervisor" },
    { label: "Contracting Company", key: "contractingcompany" },
    { label: "Primary Industry", key: "primaryindustry" },
    { label: "Secondary Industry", key: "secondaryindustry" },
    { label: "Expertise", key: "expertise" },
    { label: "Industry Role", key: "industryrole" },
    { label: "Designation", key: "designation" },
    { label: "Grade", key: "grade" },
    { label: "Target Chargeability %", key: "targetchargeability" },
    { label: "Charge Out Rate", key: "chargeoutrate" },
    { label: "Last Promotion Date", key: "lastpromotiondate" },
    { label: "Last Promotional Level", key: "lastpromotionlevel" },
    { label: "Job Title", key: "jobtitle" },
    { label: "Professional Since", key: "professionalsince" },
    { label: "Hired Date", key: "hireddate" },
    { label: "Employee Sponsor", key: "employeesponsor" },
    { label: "Job Description", key: "jobdescription" },
    { label: "Emergency Contact Name", key: "emergencycontactname" },
    { label: "Emergency Contact Number", key: "emergencycontactnumber" },
    { label: "Regional Supervisor", key: "regionalsupervisor" },
    { label: "Office Supervisor", key: "officesupervisor" },
    { label: "Engagement Supervisor", key: "engagementsupervisor" },
    { label: "Personal Email ID", key: "personalemail" },
    { label: "Subcluster", key: "subcluster" },
    { label: "Appraiser", key: "appraiser" },
  ];

  const canExportCSV =
    Array.isArray(userInfo?.role_id) &&
    (userInfo.role_id.includes(SUPER_ADMIN_ROLE_ID) ||
      userInfo.role_id.includes(HR_ROLE_ID));

  const sendMessage = () => {
    const staffIds = map(getStaffList(), "userid");
    if (size(staffIds) && broadcastMessage) {
      ToggleSendingMessageLoader(true);
      EventBus.$dispatch("sendMessage", {
        action: "BROADCAST",
        payload: {
          message: broadcastMessage,
          receiverUserIds: map(getStaffList(), "userid"),
          receiverName: map(getStaffList(), "fullname"),
        },
      });
      setTimeout(() => {
        toggleBroadcastModalVisible(false);
        ToggleSendingMessageLoader(false);
      }, 1000);
      setTimeout(() => {
        updateSuccessModal({
          visibility: true,
          message: `Message has been broadcasted.`,
        });
        setBroadcastMessage("");
      }, 1000);
    }
  };

  const userWholeData = userList.find(
    (user) => user.userid === userInfo.userid
  );

  const userManagingOffices = userWholeData?.managingoffice;

  const filteruser = userList?.filter(
    (item) => item?.userid === get(userInfo, "userid", "")
  );

  function getSubordinates(data, supervisorId) {
    let result = [];
    let visited = new Set();
    let memo = new Map();

    function findSubordinates(supervisorId) {
      if (visited.has(supervisorId)) {
        return;
      }
      if (memo.has(supervisorId)) {
        result = result.concat(memo.get(supervisorId));
        return;
      }

      visited.add(supervisorId);
      let subordinates = [];

      data.forEach((employee) => {
        if (employee.OfficeSupervisorId === supervisorId) {
          subordinates.push(employee);
          findSubordinates(employee.employeeid);
        }
      });

      result = result.concat(subordinates);
      memo.set(supervisorId, subordinates);
    }

    findSubordinates(supervisorId);
    return result;
  }

  const subordinates = getSubordinates(
    userList?.filter((val) => val?.statusid?.toString() === "1"),
    filteruser[0]?.employeeid
  );

  const getStaffList = () => {
    const allStaffList = userList;
    const isSuperAdmin = userRoleId === "2";
    var staffList;

    staffList =
      url === "myteam"
        ? subordinates
        : allStaffList
          ?.filter((item) => item?.statusid === employeeType) // Filter by active/inactive
          ?.filter((item) => {
            if (isSuperAdmin) {
              return true;
            }

            // Direct managing-office match
            const isOnSameCountry = userManagingOffices?.some((office) => {
              return item.managingoffice?.includes(office);
            });

            return isOnSameCountry;
          });
    return uniqBy(staffList, "userid");
  };

  const fetchMasterData = async (fetch_master_data) => {
    const [{ code, levelList }, userListResponse] = await Promise.all([
      CALL_API(`master-data/${clientId}`, "post", { fetch_master_data }),
      fetch_master_data
        ? FETCH_FULL_USER_LIST(clientId)
        : Promise.resolve({}),
    ]);

    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_data) {
        let level1_values = [];
        let level2_values = [];
        let level3_values = [];
        let level4_values = [];
        let level5_values = [];

        updateUserList(userListResponse?.userList);

        levelList.forEach((level) => {
          switch (level.levelName) {
            case "Level1":
              level.value.forEach((value) => {
                value.value.forEach((item) => {
                  level1_values.push(item);
                });
              });
              break;
            case "Level2":
              level.value.forEach((value) => {
                value.value.forEach((item) => {
                  level2_values.push(item);
                });
              });
              break;
            case "Level3":
              level.value.forEach((value) => {
                value.value.forEach((item) => {
                  level3_values.push(item);
                });
              });
              break;
            case "Level4":
              level.value.forEach((value) => {
                value.value.forEach((item) => {
                  level4_values.push(item);
                });
              });
              break;
            case "Level5":
              level.value.forEach((value) => {
                value.value.forEach((item) => {
                  level5_values.push(item);
                });
              });
              break;
            default:
              break;
          }
        });

        setManagingOfficeData(Array.from(level1_values));
        setCompetencyQCfetchData(Array.from(level2_values));
        setServicelinefetchData(Array.from(level3_values));
        setsubservicelineData(Array.from(level4_values));
        setDepartmentLevelData(Array.from(level5_values));
      }
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <Link
          onClick={() => toggleAddEmployeeModal(true)}
          className="fw-semibold"
        >
          New Employee Form
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link to="pending-employee" className="fw-semibold">
          Pending Employee
        </Link>
      ),
    },
  ];

  const linkToCopy = `https://www.uat.onboarding.bdo.insyts.co/?id=${encryptedClientId}`;
  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => {
        message.success("Link copied");
      })
      .catch(() => {
        message.error("Failed to copy link");
      });
  };

  // Tab items for Employee/Ex Employee
  const tabItems = [
    {
      key: 1,
      label: "Employee",
      children: <></>,
    },
    {
      key: 2,
      label: "Ex Employee",
      children: <></>,
    },
  ];

  const handleTabSelect = (key) => {
    if (key === 2) {
      setEmployeeType("0"); // Inactive employees
    } else {
      setEmployeeType("1"); // Active employees
    }
    setActiveTabKey(key);
  };

  const { FilterJSX, getFilterList } = useEmployeeFilter({
    employeeFilterList: employeeFilterList,
    containerRef,
    managingOfficeData,
    competencyQCData,
    departmentLevelData,
    subservicelineData,
    servicelineData,
    showFilters: {
      managingOffice: false,
      serviceline: true,
      competencyQC: true,
      team: true,
      leveldepartmentname: url !== "myteam",
      competencyrole: true,
      employee: true,
      supervisor: true,
      grade: true,
    },
    menuName: url === "myteam" ? "myTeam" : "hremployee",
    employeeType: employeeType,
  });

  useEffect(() => {
    let result;
    if (employeeType) {
      result = getStaffList()?.filter((data) => {
        const statusMatch = data?.statusid == employeeType;

        if (employeeType === "1") {
          return statusMatch && (data?.statusname === "active" || data?.statusid === "1");
        }

        if (employeeType === "0") {
          return statusMatch && (data?.statusname === "inactive" || data?.statusid === "0");
        }

        return statusMatch;
      });
    } else {
      result = getStaffList();
    }
    setEmployeeFilterList(result);
  }, [selectedDepartment, employeeType, userList]);

  useEffect(() => {
    if (levelList?.length > 0) {
      let level1_values = [];
      let level2_values = [];
      let level3_values = [];
      let level4_values = [];
      let level5_values = [];

      levelList.forEach((level) => {
        if (level.levelName === "Level1") {
          level.value.forEach((value) => {
            level1_values.push(...value.value);
          });
        } else if (level.levelName === "Level2") {
          level.value.forEach((value) => {
            level2_values.push(...value.value);
          });
        } else if (level.levelName === "Level3") {
          level.value.forEach((value) => {
            level3_values.push(...value.value);
          });
        } else if (level.levelName === "Level4") {
          level.value.forEach((value) => {
            level4_values.push(...value.value);
          });
        } else if (level.levelName === "Level5") {
          level.value.forEach((value) => {
            level5_values.push(...value.value);
          });
        }
      });
      setManagingOfficeData(level1_values);
      setCompetencyQCfetchData(level2_values);
      setServicelinefetchData(level3_values);
      setsubservicelineData(level4_values);
      setDepartmentLevelData(level5_values);
    }
  }, [levelList]);

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 50;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex =
    ((getFilterList().length > 50 ? currentPage : 1) - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  const getDisplayList = () => {
    return getFilterList().slice(startIndex, endIndex);
  };

  const calculateAge = (dob) => {
    if (!dob) return "";
    const birth = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  const prepareCSV = () => {
    const data = getFilterList();

    if (!data || data.length === 0) {
      message.warning("No data available to export");
      return;
    }

    const csvData = data.map((emp) => ({
      salutation: emp?.salutation || "",
      initial: emp?.initial || "",
      userid: emp?.userid || "",
      fullname: emp?.fullname || "",
      employeeid: emp?.employeeid || "",

      startdate: emp?.startdate || "",
      dob: emp?.dateofbirth || "",
      gender: emp?.gender || "",
      age: calculateAge(emp?.dateofbirth),

      maritalstatus: emp?.maritalstatus || "",
      dependents: emp?.dependent || "",
      greetings:
        emp?.salutation && emp?.fullname
          ? `${emp.salutation} ${emp.fullname}`
          : "",

      nationality: emp?.nationality || "",
      address: emp?.physicaladdress || "",
      phoneno: emp?.phoneno || "",

      managingoffice: Array.isArray(emp?.managingoffice)
        ? emp.managingoffice.join(", ")
        : emp?.managingoffice || "",

      competencyQC: Array.isArray(emp?.competencyQC)
        ? emp.competencyQC.join(", ")
        : "",

      serviceline: Array.isArray(emp?.serviceline)
        ? emp.serviceline.join(", ")
        : "",

      subserviceline: Array.isArray(emp?.subserviceline)
        ? emp.subserviceline.join(", ")
        : "",

      leveldepartmentname: Array.isArray(emp?.leveldepartmentname)
        ? emp.leveldepartmentname.join(", ")
        : "",

      competencyrole: Array.isArray(emp?.competencyrole)
        ? emp.competencyrole.join(", ")
        : "",

      institutename: emp?.educationdetails?.[0]?.institutename || "",
      location: emp?.levellocationid || "",
      supervisor: emp?.officesupervisor || "",
      contractingcompany: emp?.companyname || "",

      primaryindustry: Array.isArray(emp?.industry)
        ? emp.industry.join(", ")
        : "",

      secondaryindustry: Array.isArray(emp?.secondaryindustry)
        ? emp.secondaryindustry.join(", ")
        : "",

      expertise: emp?.expertise || "",
      industryrole: Array.isArray(emp?.industryrole)
        ? emp.industryrole.join(", ")
        : "",

      designation: emp?.designation || "",
      grade: emp?.grade || "",
      targetchargeability: emp?.targetchargeability || "",
      chargeoutrate: emp?.chargeoutrate || "",
      lastpromotiondate: emp?.lastpromotion || "",
      lastpromotionlevel: emp?.lastpromotionlevel || "",
      jobtitle: emp?.jobtitle || "",
      professionalsince: emp?.professionalsince || "",
      hireddate: emp?.hireddate || "",
      employeesponsor: emp?.employeesponser || "",

      jobdescription:
        emp?.appraisalInformation?.[0]?.jobdescriptionFileName || "",

      emergencycontactname: emp?.emergencycontactname || "",
      emergencycontactnumber: emp?.emergencycontactnumber || "",
      regionalsupervisor: emp?.regionalsupervisor || "",
      officesupervisor: emp?.officesupervisor || "",
      engagementsupervisor: emp?.engagementsupervisor || "",

      personalemail: emp?.personalemailid || "",
      physicaladdress: emp?.physicaladdress || "",
      workpermitno: emp?.workpermitno || "",
      workpermitexpiry: emp?.workpermitexpirydate || "",
      subcluster: Array.isArray(emp?.subclustercountries)
        ? emp.subclustercountries.join(", ")
        : emp?.subclustercountries || "",

      appraiser:
        emp?.appraisalInformation
          ?.map(
            (a) =>
              `${a?.appraiserName || ""}${a?.roletype ? ` (${a.roletype})` : ""
              }`
          )
          .join(" | ") || "",
    }));

    setEmployeeCSVlist(csvData);

    setTimeout(() => {
      csvLinkRef.current.link.click();
    }, 0);
  };

  return (
    <>
      {!displayAddEmployeeModal && (
        <>
          <Row className="d-flex justify-content-between mb-1">
            <Col>
              <StyledTitle className="page-title-head">
                {url === "team" ? (
                  <Row>
                    <Tabs
                      activeKey={activeTabKey}
                      items={tabItems}
                      onChange={handleTabSelect}
                      indicator={{
                        size: (origin) => origin - 20,
                        align: "center",
                      }}
                    />
                  </Row>
                ) : (
                  "List of Employee"
                )}
              </StyledTitle>
            </Col>
            <Col>
              <div>
                {url !== "myteam" && (
                  <div>
                    <CSVLink
                      data={employeeCSVlist}
                      headers={CSVHeaders}
                      filename="people-master.csv"
                      ref={csvLinkRef}
                      style={{ display: "none" }}
                    />
                    {canExportCSV && (
                      <ButtonOutlined className="m-0 me-2" onClick={prepareCSV}>
                        <span className="add-title">Export CSV File</span>
                      </ButtonOutlined>
                    )}
                    {canAddPeople && (
                      <>
                        <IconLink onClick={handleCopyClick} />
                        <Dropdown
                          menu={{ items }}
                          placement="bottom"
                          trigger={["hover"]}
                        >
                          <ButtonFilled className="apply-leave-sm">
                            Add People
                          </ButtonFilled>
                        </Dropdown>
                      </>
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {FilterJSX}

          <StyledFilterRow gutter={16}>
            <Col className="" lg={6} md={12} sm={24} xs={24}>
              <div className="people_font_style mb-2">
                Total People: {getFilterList().length}
              </div>
            </Col>
          </StyledFilterRow>

          <Row>
            {map(
              getDisplayList(),
              (
                {
                  clientid,
                  userid,
                  fullname,
                  departmentid,
                  profileurl,
                  employeeid,
                  jobtitle,
                  usertype,
                  employementtype,
                  leveldepartmentname,
                  designation,
                  grade,
                },
                index
              ) => (
                <StyledCol key={index} xs={24} sm={12} md={12} lg={8} xl={6}>
                  <Link
                    to={
                      url === "myteam"
                        ? TOPGRADESUPERVISORLIST.includes(
                          filteruser?.length > 0 ? filteruser[0]?.grade : ""
                        )
                          ? `/profile-details/${userid}?type=team`
                          : "myteam"
                        : `/profile-details/${userid}?type=hr`
                    }
                  >
                    <TeamCard
                      id={userid}
                      clientid={clientid}
                      name={fullname}
                      email_id={userid}
                      employeeid={employeeid}
                      jobtitle={jobtitle}
                      usertype={usertype}
                      employementtype={employementtype}
                      hasUnreadMessage={
                        includes(unreadChatMessageList, userid) > 0
                          ? true
                          : false
                      }
                      dept_name={result(
                        find(allDepartmentList, (val) => {
                          return val.department_id === departmentid;
                        }),
                        "department_name"
                      )}
                      profile={profileurl}
                      url={url}
                      designation={designation}
                      leveldepartmentname={leveldepartmentname}
                      grade={grade}
                    />
                  </Link>
                </StyledCol>
              )
            )}
          </Row>

          {getFilterList()?.length > pageSize && (
            <Pagination
              current={getFilterList()?.length > 50 ? currentPage : 1}
              total={getFilterList()?.length}
              pageSize={pageSize}
              onChange={handlePageChange}
              style={{ marginTop: "20px", textAlign: "center" }}
            />
          )}

          <Modal
            centered
            visible={isBroadcastModalVisible}
            closable={false}
            footer={false}
            keyboard={false}
            title="Broadcast Message"
            onCancel={() => toggleBroadcastModalVisible(false)}
          >
            <TextArea
              rows={4}
              placeholder="Type a message."
              maxLength={500}
              value={broadcastMessage}
              onChange={(e) => setBroadcastMessage(e.target.value)}
            />
            <StyledFooterDiv>
              <Button
                type="link"
                onClick={sendMessage}
                loading={sendingMessageLoader}
              >
                Send to all
              </Button>
            </StyledFooterDiv>
          </Modal>
        </>
      )}

      {displayAddEmployeeModal && (
        <AddEmployee
          isModalVisible={displayAddEmployeeModal}
          closeModal={() => toggleAddEmployeeModal(false)}
          getEmployeeList={fetchMasterData}
          EmployeeList={userList}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  userList: getUserList(state),
  userRoleId: getUserRoleId(state),
  menuList: getMenuList(state),
  allDepartmentList: getAllDepartmentList(state),
  departmentUserList: getDepartmentUserList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  unreadChatMessageList: getUnreadChatMessageList(state),
  userInfo: getUserInfo(state),
  departmentList: getDepartmentList(state),
  levelList: getlevelList(state),
  supervisorList: getSupervisorList(state),
  roleList: getRoleList(state),
  clientId: getClientid(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateSuccessModal: toggleSuccessModal,
      updateUserList: setUserList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Team);